import axios from "axios";

const API_URL = "https://bo.leaseprotect.lebackyard.ovh/api/v1"; // Default to localhost if not set

const api = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export default api;
